import React, { useState, useEffect } from "react";
import ReactTable from "react-table";
import { Button as ReactButton } from "reactstrap";
import { ComisionItem } from "../../../reducers/comision";
import { formatMoney } from "../../../helpers/formatters";

export interface TableProps {
  comisiones: ComisionItem[];
  loading: boolean;
  onDownload: () => void;
  downloading: boolean;
}

const columnsFormatter = () => [
  {
    Header: "ID",
    accessor: "idComision",
    width: 80,
    Cell: ({ value }) => <span>{value}</span>
  },
  {
    Header: "Club",
    accessor: "club",
    width: 150,
    Cell: ({ value }) => <span>{value || "N/A"}</span>
  },
  {
    Header: "Tipo Comisión",
    accessor: "tipocomision",
    width: 150,
    Cell: ({ value }) => <span>{value || "N/A"}</span>
  },
  {
    Header: "Descripción",
    accessor: "descripcion",
    minWidth: 200,
    Cell: ({ value }) => <span>{value || "N/A"}</span>
  },
  {
    Header: "Folio Factura",
    accessor: "folioFactura",
    width: 130,
    Cell: ({ value }) => <span>{value || "N/A"}</span>
  },
  {
    Header: "Importe",
    accessor: "importe",
    width: 120,
    Cell: ({ value }) => <span>{formatMoney(value || 0)}</span>
  },
  {
    Header: "Porcentaje",
    accessor: "porcentaje",
    width: 100,
    Cell: ({ value }) => <span>{value ? `${value}%` : "0%"}</span>
  },
  {
    Header: "Monto Comisión",
    accessor: "montoComision",
    width: 140,
    Cell: ({ value }) => <span>{formatMoney(value || 0)}</span>
  },
  {
    Header: "Estatus",
    accessor: "estatusComision",
    width: 120,
    Cell: ({ value }) => <span>{value || "N/A"}</span>
  },
  {
    Header: "Fecha Autorización",
    accessor: "fechaAutorizacion",
    width: 150,
    Cell: ({ value }) => <span>{value || "N/A"}</span>
  },
  {
    Header: "Usuario Autorización",
    accessor: "usuarioAutorizacion",
    width: 180,
    Cell: ({ value }) => <span>{value || "N/A"}</span>
  }
];

export const MemoTable = React.memo(
  ({ comisiones, loading, onDownload, downloading }: TableProps) => {
    const [columns, setColumns] = useState(columnsFormatter());

    useEffect(() => {
      setColumns(columnsFormatter());
    }, []);

    return (
      <div>
        <div className="row">
          {!!comisiones && !!comisiones.length && (
            <div className="col-6 p-0" style={{ lineHeight: "40px" }}>
              <span>
                &nbsp;&nbsp;&nbsp;&nbsp;Comisiones mostradas:{" "}
                {comisiones.length}
              </span>
            </div>
          )}
          {!!comisiones && !!comisiones.length && (
            <div
              className="col-6 p-0 text-right"
              style={{ lineHeight: "40px" }}
            >
              <ReactButton
                color="primary"
                size="sm"
                onClick={onDownload}
                disabled={downloading || !comisiones || !comisiones.length}
              >
                {downloading ? "Descargando..." : "Descargar"}
              </ReactButton>
              &nbsp;&nbsp;&nbsp;&nbsp;
            </div>
          )}
        </div>
        <ReactTable
          manual
          data={comisiones || []}
          columns={columns}
          loading={loading}
          showPagination={false}
          defaultPageSize={comisiones ? comisiones.length : 0}
          minRows={5}
          noDataText="No se encontraron comisiones"
          className="-striped -highlight"
        />
      </div>
    );
  }
);
